import { client } from '../../../../../common-utils/libraries/axios/axios';
import USERS from '../../../users/monetic/api/apiUrls';

const mutationForgottenPassword = (onSuccess, onError) => {
    return {
        mutationFn: ({ email }) => {
            return client.post(USERS.FORGOTTEN_PASSWORD.url, { email });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationForgottenPassword;